// extracted by mini-css-extract-plugin
module.exports = {"cus-mtdicon":"jj","cusMtdicon":"jj"};